import React, { useState, useEffect } from 'react';
import { questionCodeName } from '../../../../../src/shared/types/constants';
import { Icon } from '../..';
import { formatCurrency, tryParseFloat, tryParseNumber } from '../../../../shared';
import './input-currency.scss';
export var InputCurrency = function (_a) {
    var _b, _c;
    var id = _a.id, required = _a.required, error = _a.error, disabled = _a.disabled, placeHolder = _a.placeHolder, setValue = _a.setValue, value = _a.value, isDisplay = _a.isDisplay, register = _a.register, watch = _a.watch, question = _a.question, questionSet = _a.questionSet;
    var inputCurrencyClasses = 'c-input-currency';
    var inputClasses = 'c-input';
    var amountPaid;
    var interestPaid;
    var watchLoanAmount = watch("".concat(id));
    var _d = useState(0), currencyValue = _d[0], setCurrencyValue = _d[1];
    var _e = useState(''), currencyDisplay = _e[0], setCurrencyDisplay = _e[1];
    var _f = useState(false), addDecimal = _f[0], setAddDecimal = _f[1];
    var setWatchValue = function (id, question) {
        var idPart = id.split('-');
        return watch("".concat(idPart[0], "-").concat(question.id, "-").concat(idPart[2]));
    };
    if (question.code == questionCodeName.loanAmount) {
        var amountPaidQuestion = (_b = questionSet === null || questionSet === void 0 ? void 0 : questionSet.questions) === null || _b === void 0 ? void 0 : _b.find(function (q) { return q.code == questionCodeName.amountPaid; });
        var interestPaidQuestion = (_c = questionSet === null || questionSet === void 0 ? void 0 : questionSet.questions) === null || _c === void 0 ? void 0 : _c.find(function (q) { return q.code == questionCodeName.interestPaid; });
        if (!!amountPaidQuestion) {
            amountPaid = setWatchValue(id, amountPaidQuestion);
        }
        if (!!interestPaidQuestion) {
            interestPaid = setWatchValue(id, interestPaidQuestion);
        }
    }
    var formatDisplayedCurrency = function (amount) {
        setCurrencyDisplay(formatCurrency(amount));
    };
    var handleCurrencyChange = function (e) {
        var value = currencyValue;
        if ((e === null || e === void 0 ? void 0 : e.key) === 'Backspace') {
            var currencyText = currencyValue.toString();
            value = tryParseFloat(currencyText.substring(0, currencyText.length - 1), 0).value;
            setCurrencyValue(value);
        }
        else if ((e === null || e === void 0 ? void 0 : e.key) === '.') {
            setAddDecimal(true);
            return;
        }
        else if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(e === null || e === void 0 ? void 0 : e.key))) {
            value = tryParseFloat("".concat(currencyValue).concat(addDecimal ? '.' : '').concat(e === null || e === void 0 ? void 0 : e.key), 0).value;
            setCurrencyValue(value);
        }
        setAddDecimal(false);
        setValue(id, value.toString());
        formatDisplayedCurrency(value);
    };
    var clearInput = function () {
        if (question.code == questionCodeName.loanAmount &&
            (parseFloat(amountPaid) > parseFloat(watchLoanAmount) || parseFloat(interestPaid) > parseFloat(watchLoanAmount))) {
            setCurrencyDisplay('');
            setCurrencyValue(0);
        }
    };
    if (disabled) {
        inputClasses += ' isDisabled';
    }
    if (error) {
        inputClasses += ' isInvalid';
    }
    if (required) {
        inputClasses += ' isRequired';
        inputCurrencyClasses += ' isRequired';
    }
    if (value) {
        inputClasses += ' hasValue';
    }
    useEffect(function () {
        if (value) {
            formatDisplayedCurrency(tryParseNumber(value));
            setCurrencyValue(tryParseNumber(value));
        }
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: inputCurrencyClasses },
            React.createElement("span", { className: "c-input-currency__icon" },
                React.createElement(Icon, { name: "pound" })),
            React.createElement("input", { type: "text", id: id, name: id, className: inputClasses, value: currencyDisplay, required: required, disabled: disabled, "aria-invalid": error ? 'true' : 'false', onKeyUp: handleCurrencyChange, placeholder: placeHolder, ref: register({
                    required: isDisplay && required,
                }), onFocus: clearInput })),
        question.code == questionCodeName.loanAmount &&
            (tryParseNumber(amountPaid) > tryParseNumber(watchLoanAmount) ||
                tryParseNumber(interestPaid) > tryParseNumber(watchLoanAmount)) ? (React.createElement("span", { className: "c-question-set__error-text" }, "Please ensure that the specified value of Amount paid on an annuity basis is not greater than the Loan Amount.")) : (React.createElement("span", null))));
};
